import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectApiVersion: {
    description: 'Label for the Select component',
    defaultMessage: 'Select API Version',
    id: 'v/BxqR',
  },
  generateV1Keys: {
    description: 'Button title',
    defaultMessage: 'Generate API Key',
    id: 'j222mJ',
  },
  generatingV1Keys: {
    description: 'Button title',
    defaultMessage: 'Generating API Key...',
    id: 'E4sZ9F',
  },
  limitReachedToolTipContent: {
    defaultMessage:
      'Limit reached: You can only have {apiKeyLimit} API {apiKeyLimit, plural, one {key} other {keys}}. Delete {keyCountToDelete, plural, one {# key} other {# keys}} to create a new key.',
    id: 'PyTdZN',
    description: 'Message for the tooltip when the API V1 limit reached',
  },
});
